<template lang="pug">
.py-30.px-50.text-left
    .font-700.text-24 {{$t('__c6N3.__createYourCustomizedUpdateSettings')}}
    //- div {{$store.state.common.frequency[1]}} {{form.frequency['id']}}
    //- div {{form.frequency}}
    hr.border-t-2.my-16
    Stepper.mt-72.mb-104.w-352.m-auto(@changeStep="changeStep" :currentStep="currentStep" :stepInfo="stepInfoResult")
    //- Transition(name="slide-up" mode="out-in" appear :duration="500")
    div
      div(v-if="currentStep== 0" :key="1")
        .mx-40.px-40.py-32.bg-grey-f7.rounded-10
          .font-600.text-24.text-center.pb-40 {{$t('__c6N3.__updateSetting')}}
          div
            //- .row.mb-18.flex.items-center  //五月resource功能做一半到時再開
            //-     label.font-500.min-w-200.inline-block.text-16.mr-16.flex.items-center
            //-       span.font-600 Resource
            //-     .w-full 
            //-       Select.max-w-576(
            //-         :defaultSelectedValue="form.resource" 
            //-         :optionArr="frequencyMulti" 
            //-         :required="true"
            //-         :isSearch="false"
            //-         @onClick="selectFrequency"
            //-         @onblur="toblur" 
            //-         name="frequency"
            //-         :placeholder="$t('__c6N3.__manualUpdatesOnlyWeeklyMonthly')")
            //- .row.mb-18.flex.items-center
            //-     label.font-500.min-w-200.inline-block.text-16.mr-16.flex.items-center
            //-     .w-full
            //-       Input.max-w-576.mr-10(type="text" @onKey="versionValid" :maxLength="'50'" :error="error.fileName" v-model="form.fileName"  )
            .row.mb-18.flex.items-center
              label.font-500.min-w-200.inline-block.text-16.mr-16.flex.items-center
                //- .text-main-0.pt-8.mr-5.align-middle.text-20 *
                span.font-600 {{$t('__c6N3.__frequency')}}
              .w-full 
                Select.max-w-576(
                  :defaultSelectedValue="form.frequency" 
                  :optionArr="frequencyMulti" 
                  :required="true"
                  :isSearch="false"
                  @onClick="selectFrequency"
                  @onblur="toblur" 
                  name="frequency"
                  :placeholder="$t('__c6N3.__manualUpdatesOnlyWeeklyMonthly')")
            .row.my-18.flex.items-center(v-if="form.frequency ? form.frequency['id'] == $store.state.common.frequency[1] || form.frequency['id'] == $store.state.common.frequency[2] : false")
              label.font-500.min-w-200.inline-block.text-16.mr-16
              .w-full 
                div(class="xl:flex")
                  Select.max-w-full.iconCalender(
                    class="xl:w-282 xl:mr-12"
                    v-if="form.frequency ? form.frequency['id'] == $store.state.common.frequency[1] : false"
                    :defaultSelectedValue="form.weekDay" 
                    :optionArr="dayOption" 
                    :required="true"
                    :isSearch="false"
                    @onClick="selectWeekDay"
                    @onblur="toblur" 
                    name="Weekly"
                    :placeholder="$t('__c6N3.__pleaseSelectADay')")
                  div(class="xl:w-282 xl:mr-12"  v-if="form.frequency ? form.frequency['id'] == $store.state.common.frequency[2] : false")
                    Calender.w-full.mr-12.iconCalender(
                      class="xl:w-282 xl:mr-12"
                      v-if="form.frequency ? form.frequency['id'] == $store.state.common.frequency[2] : false"
                      :defaultSelectedValue="form.month"
                      :optionArr="monthOption"
                      :required="true"
                      :isSearch="false"
                      @onClick="selectMonth"
                      @onblur="toblur"
                      name="Monthly"
                      :placeholder="$t('__c6N3.__pleaseSelectADay')")
                    .error.flex.items-center(v-show="error.month")
                      small.text-error.pt-3 {{error.month}}
                  TimePicker.w-full.mt-18(format="HH:mm" 
                  class="xl:w-280 xl:mt-0"
                  @changeTime="changeTime" :valueDatePicker="form.time" 
                  @toBlur="toblur")
                //- .text-error.mt-10.text-12(v-if="error.month") {{error.month}}
            .row.mb-18.flex.items-center(v-if="form.frequency ? form.frequency['id'] == $store.state.common.frequency[1]  || form.frequency['id'] == $store.state.common.frequency[2]:false " )
              label.font-500.min-w-200.inline-block.text-16.mr-16.flex.items-center
              .flex.items-center
                .div.h-24.flex.items-center
                  Checkbox(:options="localTimeList" :value="form.localTime" @changeValue="localTimeCheck")
            .row.my-18.flex.items-center(v-if="form.frequency && form.frequency['id'] != $store.state.common.frequency[0] ")
              label.font-500.min-w-200.inline-block.text-16.mr-16.flex.items-center
                //- .text-main-0.pt-8.mr-5.align-middle.text-20 *
                span.font-600 {{$t('__c6N3.__updateBehavior')}} 
              .w-full 
                Select.max-w-576(
                  :defaultSelectedValue="form.updateBehavior" 
                  :optionArr="updateBehaviorMulti" 
                  :required="true"
                  :isSearch="false"
                  @onClick="selectUpdateBehavior"
                  @onblur="toblur" 
                  name="frequency"
                  :placeholder="$t('__c6N3.__notifyOnlyDownloadInstall')")
            .row.mb-18.flex.items-center
              label.font-500.min-w-200.inline-block.text-16.mr-16.flex.items-center
              .flex.items-center
                .div.h-24.flex.items-center
                  Checkbox(v-if="form.updateBehavior && form.updateBehavior['id'] == 'AutoUpdate'"  :options="postponeList" :value="form.postpone" @changeValue="postponeCheck") 
        .mx-40.px-40.py-32.bg-grey-f7.rounded-10.mt-16
          .font-600.text-24.text-center.pb-40 {{$t('__c6N3.__updateFilters')}} 
          .font-600.mb-20.text-16 {{$t('__c6N3.__driver')}} / {{$t('__c6N3.__firmware')}}
          .ml-40
            .row.mb-18.flex.items-start
              label.font-500.min-w-200.inline-block.text-16.mr-16.flex.items-center
                //- .text-main-0.pt-8.mr-5.align-middle.text-20 *
                span.font-600 {{$t('__c6N3.__severity')}}
              .w-full
                Checkbox(:options="severityList" displayColumn="" label="" 
                :value="form.severity" @changeValue="severityCheck" )
            .row.my-18.flex.items-start
              label.font-500.min-w-200.inline-block.text-16.mr-16.flex.items-center
                //- .text-main-0.pt-8.mr-5.align-middle.text-20 *
                span.font-600 {{$t('__c6N3.__category')}}
              .w-full 
                InputSelect.w-228(
                  :error="''"
                  :defaultSelectedValue="form.category" 
                  :optionArr="selectCategoryOption" 
                  :required="false"
                  :hasAllOption="true"
                  @onClick="categorySearch"
                  :placeholder="$t('__c6N3.__addFiltersForCategory')")
                FilterTab.mt-20(:itemList="calcCategoryFilterTab" @deleteFilter="deleteSelectCategory" :clearAll="true" )
          
          
          .row.mb-18.flex.items-start
              label.font-500.min-w-200.inline-block.text-16.mr-16.flex.items-center
                .font-600.mb-20.text-16.mt-5 {{$t('__c6N3.__windowsKb')}}
              .w-full.flex.items-center.ml-40
                ToggleSwitch.font-600(:checked.sync="form.windowsKBNotInclude" id="cookieActive" :label="''" )
                .ml-10.pt-2 {{form.windowsKBNotInclude ? $t('__c6N3.__include') : $t('__c6N3.__exclude')}}
          .ml-40
            .row.mb-18.flex.items-start
              label.font-500.min-w-200.inline-block.text-16.mr-16.flex.items-center
                span.font-600 {{$t('__c6N3.__severity')}}
              .w-full
                Checkbox(:options="categorySeverityList" displayColumn="" label="" 
                :value="form.categorySeverity" @changeValue="categorySeverityCheck" )
            .row.mb-18.flex.items-start
              label.font-500.min-w-200.inline-block.text-16.mr-16.flex.items-center
                span.font-600 {{$t('__c6N3.__category')}}
              .w-full
                //- Checkbox(:options="windowsKBCheckbox" :value="form.windowsKBNotInclude" @changeValue="windowsKBNotIncludeCheck") 
                InputSelect.w-228(
                  :error="''"
                  :isDisable="form.windowsKBNotInclude ? false : true"
                  :defaultSelectedValue="form.windowsKBSelect" 
                  :optionArr="windowsKBList" 
                  :required="false"
                  :hasAllOption="true"
                  @onClick="windowsKBSearch"
                  :placeholder="$t('__c6N3.__addFiltersForCategory')")
                FilterTab.mt-20(:itemList="calcKBFilterTab" @deleteFilter="deleteSelectWindowsKB" :clearAll="true" )
            //- .pb-50(v-if="form.frequency ? form.frequency['id'] == 1 : true")
        Button.w-180.m-20.mb-0.m-auto.mt-56( @buttonClick="stepChange(1)" type="" :text="$t('__globeButton.__next')" :disable="stepperChecker")
      div(v-else-if="currentStep== 1" :key="2")
        .mx-40
          .relative
            hr.border-t-2.my-8.w-full.absolute.top-0
          span.font-700.text-20.bg-white.z-100.relative {{$t('__c6N3.__yourConfiguration')}}
          .font-600.mb-20.text-16.mt-24 {{$t('__c6N3.__updateSetting')}}
          .my-32.mx-48.font-500 
            .row.my-24.flex.items-center(v-if="form.frequency")
              .font-500.min-w-200.text-14.mr-32  {{$t('__c6N3.__frequency')}}
              .text-grey-66
                span  {{frequencyMultiLang(form.frequency['id'])}} 
                span(v-if="form.frequency['id'] == $store.state.common.frequency[1] || $store.state.common.frequency[2]")
                  //- span(v-if="form.weekDay || form.month") {{form.frequency['id'] == $store.state.common.frequency[1] ? form.weekDay['name'] : form.month['name']}}, 
                  span(v-if="form.weekDay && form.frequency['id'] == $store.state.common.frequency[1]") {{weekDayMultiLang(form.weekDay['id'])}}
                  span(v-if="form.month && form.frequency['id'] != $store.state.common.frequency[1]") {{ form.month.name}}, 
                  span(v-if="form.time['HH']")  {{form.time['HH']}}:{{form.time['mm']}} 
                span(v-if="form.localTime[0]") ；{{$t('__c6N3.__syncAllTimeZones')}}
            .row.my-24.flex.items-center(v-if="form.updateBehavior")
              .font-500.min-w-200.text-14.mr-32  {{$t('__c6N3.__updateBehavior')}}
              .text-grey-66  {{updateBehaviorMultiLang(form.updateBehavior['id'])}} 
              span.text-grey-66(v-if="form.postpone[0]") ；{{$t('__c6N3.__allowUserToPauseUpdates')}}
          .font-600.mb-20.text-16.mt-24 {{$t('__c6N3.__updateFilters')}}
          .my-32.mx-48.font-500 
            .font-500.min-w-200.text-14.mr-32  {{$t('__c6N3.__driver')}} / {{$t('__c6N3.__firmware')}}
            .row.my-24.flex.items-center
              .font-500.min-w-160.text-14.mr-32.ml-40  {{$t('__c6N3.__severity')}}
              .text-grey-66(v-for="(e, i) in form.severity") 
                span {{severityValue(e)}}
                span(v-if="i !=form.severity.length-1") /
            .row.my-24.flex(v-if="form.category.length")
              .font-500.min-w-160.text-14.mr-32.ml-40   {{$t('__c6N3.__category')}}
              .text-grey-66.w-100.flex.flex-wrap.flex-row.w-full
                span(v-for="(e, i) in form.category") 
                  span {{calcCategory(e.id) }}
                  span(v-if="i !=form.category.length-1")  /

            .font-500.min-w-200.text-14.mr-32.flex
              div {{$t('__c6N3.__windowsKb')}}
              .text-grey-66.ml-160(v-if="!form.windowsKBNotInclude")  {{$t('__c6N3.__exclude')}} WinKB

            .row.my-24.flex(v-if="form.windowsKBNotInclude")
              .font-500.min-w-160.text-14.mr-32.ml-40  {{$t('__c6N3.__severity')}}
              .text-grey-66.w-100.flex.flex-wrap.flex-row.w-full(v-if="form.categorySeverity.length")
                div(v-for="(e, i) in form.categorySeverity") 
                  span {{severityKBValue(e)}}
                  span(v-if="i !=form.categorySeverity.length-1")  / 
            .row.my-24.flex(v-if="form.windowsKBNotInclude")
              .font-500.min-w-160.text-14.mr-32.ml-40  {{$t('__c6N3.__category')}}
              .text-grey-66.w-100.flex.flex-wrap.flex-row.w-full(v-if="form.windowsKBSelect.length")
                div(v-for="(e, i) in form.windowsKBSelect") 
                  //- span {{e.name}}
                  span {{$t(e.i18n_name)}} 
                  span(v-if="i !=form.windowsKBSelect.length-1")  / 
            
        .mx-40.px-40.py-32.bg-grey-f7.rounded-10
          div.mb-16
            .row.my-18.flex.items-start
              label.font-500.min-w-200.inline-block.text-16.mr-16.flex.items-center
                //- .text-main-0.pt-8.mr-5.align-middle.text-20 *
                span.font-600 {{$t('__c6N3.__fileName')}}
              .w-full
                Input.max-w-576.mr-10(type="text" @onKey="versionValid" :maxLength="'50'" :error="error.fileName" v-model="form.fileName" :placeholder="$t('__c6N3.__pleaseInputFileNameHere')" )

        .flex.justify-center
          Button.w-180.mr-24.mb-0.justify-center.mt-56( @buttonClick="stepChange(0)" type="borderSolid" :text="$t('__globeButton.__back')" )
          Button.w-180.mb-0.mt-56( @buttonClick="stepChange(1)" type="" :text="$t('__globeButton.__export')" :disable="stepperChecker")
    Toast(:show.sync="toast" :text="$t('__common.__success')")

</template>

<script>
import Stepper from "@/components/Stepper.vue";
import Input from "@/components/Input.vue";
import Select from "@/components/Select.vue";
import TimePicker from "@/components/TimePicker.vue";
import Button from "@/components/Button.vue";
import Checkbox from "@/components/Checkbox.vue";
import InputSelect from "@/components/InputSelect.vue";
import FilterTab from "@/components/FilterTab.vue";
import Calender from "@/components/Calender.vue";
import Toast from "@/components/Toast.vue";
import ToggleSwitch from "@/components/ToggleSwitch.vue";

import { DRIVERCATEGORYSTORE, DRIVERWINDOWSKBSTORE } from "@/enum/global";
import { configurationCreate } from "@/api/configuration.js";
import { exportHistory } from "@/api/export.js";
import { dynamicLink } from "@/api/users.js";
import { axiosDefaultsURL } from "@/api/axios";
import { encodeHTML } from "@/utils/xxsConfig.js";

export default {
  name: "CreateNew",
  components: {
    Stepper,
    Input,
    Select,
    TimePicker,
    Button,
    Checkbox,
    InputSelect,
    FilterTab,
    Calender,
    Toast,
    ToggleSwitch
  },
  data() {
    return {
      toast: false,
      apiError: null, //個別頁面的api error handler
      currentStep: 0,
      form: {
        // frequency: { "id": "3", "name": "Monthly" },
        frequency: undefined,
        weekDay: undefined,
        month: undefined,
        updateBehavior: undefined,
        time: {},
        severity: ["HIGH"],
        category: [],
        fileName: undefined,
        postpone: [],
        localTime: [],
        windowsKBNotInclude: false,
        windowsKBSelect: [],
        categorySeverity: []
        // resource: "ASUS Driver Repack (Default)" //五月resource功能做一半到時再開
      },
      error: {
        frequency: undefined,
        weekDay: undefined,
        month: undefined,
        updateBehavior: undefined,
        time: undefined,
        severity: undefined,
        fileName: undefined,
        category: undefined,
        categorySeverity: undefined
      },
      monthOption: [],
      valueDatePicker: "",
      check: [],
      resourceCustomize: ""
    };
  },
  async created() {
    for (let i = 0; i < 31; i++) {
      this.monthOption.push({ id: i + 1, name: i + 1 });
    }
  },
  async mounted() {
    this.$store.commit("common/setGoIndexRefresh", true);
  },
  methods: {
    localTimeCheck(v) {
      this.form.localTime = v;
    },
    postponeCheck(v) {
      this.form.postpone = v;
    },
    windowsKBSearch(e) {
      this.form.windowsKBSelect = e;
    },
    deleteSelectWindowsKB(i) {
      if (i == "all") {
        this.form.windowsKBSelect = [];
      } else {
        this.form.windowsKBSelect.splice(i, 1);
      }
    },
    changeStep(e) {
      this.currentStep = e.index;
    },
    selectFrequency(e) {
      this.form.frequency = e;
      this.form.weekDay = undefined;
      this.form.month = undefined;
      this.form.time = {};
      this.form.updateBehavior = undefined;
      this.form.localTime = [];
      this.form.postpone = [];
    },
    selectWeekDay(e) {
      this.form.weekDay = e;
      this.form.time = {};
      // console.log(this.form)
    },
    selectMonth(e) {
      this.form.month = e;
      this.form.time = {};
    },
    selectUpdateBehavior(e) {
      this.form.updateBehavior = e;
    },
    toblur(e) {
      //檢視格式
      this.error.month = "";
      if (this.form.frequency) {
        if (this.form.frequency["id"] == this.$store.state.common.frequency[2]) {
          if (this.form.month) {
            if (this.form.month["id"] >= this.monthOption[this.monthOption.length - 3]["id"]) {
              this.error.month = this.errorValidDay;
            }
          }
        }
      }
    },
    changeTime(e) {
      let temp = e;
      if (e["HH"] && !e["mm"]) {
        temp["mm"] = "00";
      }
      this.form.time = temp;
    },
    stepChange(flag) {
      if (flag) {
        //只有兩步驟0,1
        if (this.currentStep < 1) {
          this.currentStep += 1;
        } else {
          this.createConfiguration();
        }
      } else {
        this.currentStep -= 1;
      }
    },
    async createConfiguration() {
      let day =
        this.form.frequency["id"] == "Manual"
          ? undefined
          : this.form.frequency["id"] == "Monthly"
          ? this.form.month["id"]
          : this.form.weekDay["id"];
      let time =
        this.form.frequency["id"] == "Manual"
          ? undefined
          : `${this.form.time["HH"]}:${this.form.time["mm"]}:00`;
      let catArr = this.form.category.map(item => item.id);
      catArr = Array.from(new Set(catArr));
      //檢查延遲跟時區同步
      let postponeBoolean = this.form.postpone[0] ? this.form.postpone[0] == "postpone" : false;
      let localTimeBoolean = this.form.localTime[0] ? this.form.localTime[0] == false : true;
      let updateBehavior = this.form.updateBehavior ? this.form.updateBehavior["id"] : undefined;
      let sendData = {
        update_behavior: updateBehavior,
        auto_check_frequency: this.form.frequency["id"], //需等候調整
        severity: this.form.severity,
        category: catArr,
        day: day ? Number(day) : null,
        time: time,
        filename: this.form.fileName,
        behavior_is_pause_disabled: postponeBoolean,
        is_local_time: localTimeBoolean,
        windows_kb_category: this.form.windowsKBSelect.map(item => item.id),
        windows_kb_severity: this.form.categorySeverity
      };
      sendData = Object.fromEntries(Object.entries(sendData).filter(([_, v]) => v != null));
      try {
        const { data } = await configurationCreate(sendData);

        if (data) {
          this.exportFile(data.id, data.filename);
          this.resetForm();
          this.currentStep = 0;
          this.isSurveyNeeded();
        }
      } catch (error) {
        this.apiError = error.response.status;
      }
    },

    isSurveyNeeded() {
      this.$root.getUserInfo();
    },

    async exportFile(fileId, filename) {
      let id = fileId.toString();
      const sendData = {
        filename: filename
      };
      try {
        const { data } = await exportHistory(id, sendData);
        //console.log('???',data)
        this.downloadFile(data, filename);
      } catch (error) {
        this.apiError = error.response.status;
      }
      //比較偷懶但比較好用的方法，直接倒連結
      // let id  = fileId.toString();
      // let localURL = `${axiosDefaultsURL}configuration/${id}/export/?filename=${filename}`
      // if(process.env.VUE_APP_ENV == ENV.UAT  || process.env.VUE_APP_ENV == ENV.PRODUCTION){
      //   try{
      //     await dynamicLink(localURL);
      //     console.log('env pro link is valid?',localURL);
      //     this.downloadFile(localURL)
      //   }
      //   catch (error) {
      //     this.apiError = error.response.status;
      //     console.log('inside error')
      //   }
      // }else{
      //   console.log('env local',localURL)
      //   this.downloadFile(localURL)
      // }
    },

    async downloadFile(blob, filename) {
      const url = window.URL.createObjectURL(new Blob([blob]));
      const link = document.createElement("a");
      link.setAttribute("rel", "noopener"); //安全性問題預防
      link.href = url;
      link.setAttribute("download", `${filename}.config`); //or any other extension
      document.body.appendChild(link);
      link.click();
      window.URL.revokeObjectURL(url);
      document.body.removeChild(link);

      this.toast = true;
    },

    resetForm() {
      for (const key in this.form) {
        if (key == "time") {
          this.form[key] = {};
        } else if (key == "severity") {
          this.form[key] = ["HIGH"];
        } else if (
          key == "category" ||
          key == "localTime" ||
          key == "postpone" ||
          key == "windowsKBSelect" ||
          key == "categorySeverity"
        ) {
          this.form[key] = [];
        } else if (key == "windowsKBNotInclude") {
          this.form[key] = false;
        } else {
          this.form[key] = undefined;
        }
      }
    },
    severityCheck(v) {
      let valArr = Object.values(this.severityList).map(item => item.val);
      if (
        v.indexOf(this.$store.state.common.severity[0]) > -1 &&
        this.form.severity.indexOf(this.$store.state.common.severity[1]) < 0
      ) {
        this.$nextTick(function() {
          this.form.severity = valArr;
        });
      }
      this.form.severity = v;
    },
    categorySeverityCheck(v) {
      this.form.categorySeverity = v;
    },
    categorySearch(e) {
      this.form.category = e;
    },
    deleteSelectCategory(i) {
      if (i == "all") {
        this.form.category = [];
      } else {
        this.form.category.splice(i, 1);
      }
    },

    versionValid() {
      if (this.form.fileName) {
        // console.log('match', !/^[A-Za-z][A-Za-z0-9]*$/.test(this.form['fileName']) )  .match(/^[A-Za-z0-9./w]+$/)
        if (!this.form["fileName"].match(/^[\w\-(){}A-Za-z0-9.]+$/)) {
          this.error.fileName = this.errorValidFileName;
        } else {
          this.error.fileName = "";
        }
      }
    },
    severityValue(v) {
      let a;
      this.severityList.map(e => {
        if (e.val == v) {
          a = e.name;
        }
      });
      return a;
    },
    severityKBValue(v) {
      let a;
      this.categorySeverityList.map(e => {
        if (e.val == v) {
          a = e.name;
        }
      });
      return a;
    },
    updateBehaviorMultiLang(e) {
      if (e == "NotifyOnly") {
        return this.$t("__c6N3.__notifyOnly");
      } else {
        return this.$t("__c6N3.__downloadInstall");
      }
    },
    frequencyMultiLang(item) {
      let useList = {
        Weekly: "__c6N3.__weekly",
        Manual: "__c6N3.__manual",
        Monthly: "__c6N3.__monthly"
      };
      return this.$t(useList[item]);
    },
    weekDayMultiLang(item) {
      let weekList = [
        "__common.__sunday",
        "__common.__monday",
        "__common.__tuesday",
        "__common.__wednesday",
        "__common.__thursday",
        "__common.__friday",
        "__common.__saturday"
      ];
      return this.$t(weekList[item]);
    },
    calcCategory(e) {
      let a = DRIVERCATEGORYSTORE[e];
      return this.$t(`__c6N3.${a}`);
    }
  },
  computed: {
    calcCategoryFilterTab() {
      let temp = [];
      for (let i = 0; i < this.form.category.length; i++) {
        let a = DRIVERCATEGORYSTORE[this.form.category[i].id];
        temp.push({
          name: this.$t(`__c6N3.${a}`),
          id: this.form.category[i].id
        });
      }
      return temp;
    },
    calcKBFilterTab() {
      let temp = [];
      for (let i = 0; i < this.form.windowsKBSelect.length; i++) {
        let a = DRIVERWINDOWSKBSTORE[this.form.windowsKBSelect[i].id];
        temp.push({
          name: this.$t(`${a}`),
          id: this.form.windowsKBSelect[i].id
        });
      }
      return temp;
    },
    errorValidFileName() {
      let text = `${this.$t("__c6N3.__thisIsNotAValidFileName")}<br>
      ${this.$t("__c6N3.__pleaseMakeSureTheFileName")} <br>
      ${this.$t("__c6N3.__theFileNameOnlyAllows")} <br>
      ${this.$t("__c6N3.__theFileNameCannotContain")}<br>
      ${this.$t("__c6N3.__theFileNameShouldNotBeFullWidthText")}`;
      return text;
    },
    errorValidDay() {
      return this.$t("__c6N3.__ifTheSelectedDayForASpecificMonth");
    },
    selectCategoryOption() {
      let temp = [];
      if (this.$store.state.common.categories) {
        for (let i = 0; i < this.$store.state.common.categories.length; i++) {
          let a = DRIVERCATEGORYSTORE[this.$store.state.common.categories[i]];
          temp.push({
            name: this.$t(`__c6N3.${a}`),
            id: this.$store.state.common.categories[i]
          });
        }
      }
      return temp;
    },
    windowsKBList() {
      let temp = [];
      if (this.$store.state.common.windowsKB) {
        for (let i = 0; i < this.$store.state.common.windowsKB.length; i++) {
          let a = DRIVERWINDOWSKBSTORE[this.$store.state.common.windowsKB[i]];
          temp.push({
            i18n_name: a,
            name: this.$t(`${a}`),
            id: this.$store.state.common.windowsKB[i]
          });
        }
      }
      return temp;
    },
    dayOption() {
      //
      return [
        { id: "0", name: this.$t("__common.__sunday"), i18n: "__common.__sunday" },
        { id: "1", name: this.$t("__common.__monday"), i18n: "__common.__monday" },
        { id: "2", name: this.$t("__common.__tuesday"), i18n: "__common.__tuesday" },
        { id: "3", name: this.$t("__common.__wednesday"), i18n: "__common.__wednesday" },
        { id: "4", name: this.$t("__common.__thursday"), i18n: "__common.__thursday" },
        { id: "5", name: this.$t("__common.__friday"), i18n: "__common.__friday" },
        { id: "6", name: this.$t("__common.__saturday"), i18n: "__common.__saturday" }
      ];
    },
    updateBehaviorMulti() {
      //
      let temp = [];
      if (this.$store.state.common.behavior) {
        temp = [
          {
            id: this.$store.state.common.behavior[0],
            name: this.$t("__c6N3.__notifyOnly"),
            i18n: "__c6N3.__notifyOnly"
          },
          {
            id: this.$store.state.common.behavior[1],
            name: this.$t("__c6N3.__downloadInstall"),
            i18n: "__c6N3.__downloadInstall"
          }
        ];
      }
      return temp;
    },
    frequencyMulti() {
      //
      let temp = [];
      if (this.$store.state.common.frequency) {
        temp = [
          {
            name: this.$t("__c6N3.__manual"),
            id: this.$store.state.common.frequency[0],
            disabled: false,
            i18n: "__c6N3.__manual"
          },
          {
            name: this.$t("__c6N3.__weekly"),
            id: this.$store.state.common.frequency[1],
            disabled: false,
            i18n: "__c6N3.__weekly"
          },
          {
            name: this.$t("__c6N3.__monthly"),
            id: this.$store.state.common.frequency[2],
            disabled: false,
            i18n: "__c6N3.__monthly"
          }
        ];
      }
      return temp;
    },
    stepInfoResult() {
      let temp = JSON.parse(JSON.stringify(this.stepInfo));
      for (let i = 0; i < temp.length; i++) {
        if (i <= this.currentStep) {
          this.$set(temp[i], "disable", false);
        }
      }
      // this.$set(temp[this.currentStep+1], 'disable', this.stepperChecker); //如果只要下一步
      return temp;
    },
    // eslint-disable-next-line vue/return-in-computed-property
    stepperChecker() {
      let isOpen = true;
      switch (this.currentStep) {
        case 0:
          if (
            this.form.frequency &&
            this.form.severity &&
            this.form.category.length &&
            ((this.form.windowsKBSelect.length && this.form.categorySeverity.length) ||
              !this.form.windowsKBNotInclude)
          ) {
            if (this.form.frequency["id"] == this.$store.state.common.frequency[0]) {
              isOpen = false;
            } else if (this.form.frequency["id"] == this.$store.state.common.frequency[1]) {
              if (this.form.weekDay && this.form.time["HH"] && this.form.updateBehavior) {
                isOpen = false;
              }
            } else if (this.form.frequency["id"] == this.$store.state.common.frequency[2]) {
              if (this.form.month && this.form.time["HH"] && this.form.updateBehavior) {
                isOpen = false;
              }
            } else {
              isOpen = false;
            }
          }

          return isOpen;
        case 1:
          if (this.form.fileName && this.form.fileName != " " && !this.error.fileName) {
            isOpen = false;
          }
          return isOpen;
      }
    },
    stepInfo() {
      return [
        {
          title: this.$t("__c6N3.__customizedSettings"),
          value: "step1",
          disable: false,
          selected: false
        },
        {
          title: this.$t("__c6N3.__exportConfiguration"),
          value: "step2",
          disable: true,
          selected: false
        }
      ];
    },
    categorySeverityList() {
      //
      let temp = [];
      temp = [
        {
          name: this.$t("__c6N3.__extrahigh"),
          val: this.$store.state.common.windowsKBSeverity[3],
          disabled: true
        },
        {
          name: this.$t("__c6N3.__high"),
          val: this.$store.state.common.windowsKBSeverity[2],
          disabled: !this.form.windowsKBNotInclude
        },
        {
          name: this.$t("__c6N3.__normal"),
          val: this.$store.state.common.windowsKBSeverity[1],
          disabled: !this.form.windowsKBNotInclude
        },
        {
          name: this.$t("__c6N3.__low"),
          val: this.$store.state.common.windowsKBSeverity[0],
          disabled: !this.form.windowsKBNotInclude
        }
      ];
      // if (this.$store.state.common.severity) {
      // }
      return temp;
    },
    severityList() {
      //
      let temp = [];
      if (this.$store.state.common.severity) {
        temp = [
          {
            name: this.$t("__c6N3.__urgent"),
            val: this.$store.state.common.severity[2],
            disabled: true
          },
          {
            name: this.$t("__c6N3.__recommend"),
            val: this.$store.state.common.severity[1],
            disabled: false
          },
          {
            name: this.$t("__c6N3.__optional"),
            val: this.$store.state.common.severity[0],
            disabled: false
          }
        ];
      }
      return temp;
    },
    windowsKBCheckbox() {
      let temp = [];
      temp = [
        {
          name: "Not include",
          val: "notInclude",
          disabled: false
        }
      ];

      return temp;
    },
    postponeList() {
      //
      let temp = [];
      temp = [
        {
          name: this.$t("__c6N3.__allowUserToPauseUpdates"),
          val: "postpone",
          disabled: false
        }
      ];

      return temp;
    },
    localTimeList() {
      //
      let temp = [];
      temp = [
        {
          name: this.$t("__c6N3.__syncAllTimeZones"),
          val: "localTime",
          disabled: false
        }
      ];

      return temp;
    }
  },
  watch: {
    "$store.state.common.goIndexRefresh": function(n) {
      if (!n) {
        this.currentStep = 0;
        this.resetForm();
        this.$store.commit("common/setGoIndexRefresh", true);
      }
    },
    stepperChecker: {
      handler: function(n) {},
      deep: true
    },
    "form.windowsKBNotInclude": {
      handler: function(n) {
        this.form.windowsKBSelect = [];
        if (n) {
          this.form.categorySeverity = [this.$store.state.common.windowsKBSeverity[3]];
        } else {
          this.form.categorySeverity = [];
        }
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.fade-enter-active,
.fade-leave-active {
  & > * {
    transition-duration: 200ms;
    transition-property: opacity, transform;
    transition-timing-function: cubic-bezier(0.6, 0.15, 0.35, 0.8);
  }
}

$delay: 100ms;
$delayStep: 100ms;

.fade-enter,
.fade-leave-to {
  & > * {
    opacity: 0;
    transform: translateY(40px);
  }
}
.fade-enter-active {
  & > * {
    &:nth-child(2) {
      transition-delay: $delay;
    }
    &:nth-child(3) {
      transition-delay: $delay + $delayStep;
    }
  }
}
.fade-leave-active {
  & > * {
    &:nth-child(1) {
      transition-delay: $delay + $delayStep;
    }
    &:nth-child(2) {
      transition-delay: $delay;
    }
  }
}

.slide-up-enter-active,
.slide-up-leave-active {
  transition-duration: 200ms;
  transition: all 0.2s cubic-bezier(1, 0.5, 0.8, 1);
}

.slide-up-enter-from {
  // opacity: 0;
  transition-delay: 1s;
  transform: translateX(30px);
}

// .slide-up-enter-to {
//   transition-delay: 0.3s;
//   transform: translateX(30px);
// }

.slide-up-leave-to {
  opacity: 0;
  transform: translateX(-30px);
}
</style>
